import { createAction } from 'typesafe-actions'

export const createErrorAction = <T extends string, E extends Error = Error>(
  actionType: T
) => createAction(actionType, (action) => (error: E) => action(error))
